import useMediaQuery from "@mui/material/useMediaQuery";
import { FormItemTypes } from "../../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { EditableDataGrid } from "../../../../../builderPackage/components/editableDataGrid/editableDataGrid";
import { Box, Chip, Link, Stack, Typography } from "@mui/material";
import { DynamicFormBuilderContainer } from "../../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { useState } from "react";
import dayjs from "dayjs";
import { useAppSelector } from "../../../../../store/hooks";
export var HistoryTab = function (props) {
    var _value$history$length2, _value$history2;
    var value = props.value, onChange = props.onChange;
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var crud = useAppSelector(function (state) { return state.crud; });
    var columns = [{
            type: "singleSelect",
            field: "id",
            headerName: "Sr.No",
            editable: false,
            minWidth: 80,
            renderCell: function (params) { return params.api.getAllRowIds().indexOf(params.id) + 1; }
        }, {
            type: "string",
            field: "DateTime",
            headerName: "Date & Time",
            editable: false,
            minWidth: 180,
            valueFormatter: function (params) { return dayjs(params).format("DD MMM, YYYY - hh:mm A"); }
        }, {
            type: "string",
            field: "Name",
            headerName: "User",
            editable: false,
            minWidth: 150
        }, {
            type: "string",
            field: "Department",
            headerName: "Department",
            editable: false,
            minWidth: 180
        }, {
            type: "string",
            field: "Ageing",
            headerName: "Ageing days",
            editable: false,
            minWidth: 150
        }, {
            type: "string",
            field: "Remark",
            headerName: "Remark",
            editable: true,
            minWidth: 250,
            flex: 1,
            valueFormatter: function (params) { return params !== null && params !== void 0 ? params : "-"; }
        }, {
            type: "string",
            field: "Status",
            headerName: "Status",
            editable: false,
            minWidth: 150,
            renderCell: function (params) {
                return /*#__PURE__*/ React.createElement(Chip, {
                    color: "info",
                    sx: {
                        borderRadius: 1,
                        px: 1,
                        fontWeight: "medium",
                        fontSize: 12
                    },
                    label: params.value
                });
            }
        }];
    var formData = [{
            type: FormItemTypes.CardComponent,
            name: '',
            sx: {
                p: 0,
                pt: 2,
                mb: 9,
                border: 0,
                borderRadius: 0
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    sx: {
                        border: "none"
                    },
                    spacing: 0,
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 12,
                            justifyContent: "center",
                            display: "flex",
                            mx: 2,
                            spacing: 0,
                            alignItems: 'center',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: 'ads',
                                    value: 'History',
                                    fontWeight: 'bold',
                                    columnSize: 0
                                }, {
                                    type: FormItemTypes.Chip,
                                    name: "all",
                                    label: '0',
                                    sx: {
                                        ml: 1
                                    },
                                    setFieldProps: function (currentValue) {
                                        var _value$history$length, _value$history;
                                        return {
                                            type: FormItemTypes.Chip,
                                            label: "".concat((_value$history$length = value === null || value === void 0 || (_value$history = value.history) === null || _value$history === void 0 ? void 0 : _value$history.length) !== null && _value$history$length !== void 0 ? _value$history$length : 0)
                                        };
                                    },
                                    columnSize: true,
                                    color: "info"
                                }, {
                                    type: FormItemTypes.Button,
                                    name: 'expand-button',
                                    columnSize: 0,
                                    color: 'secondary',
                                    size: 'small',
                                    sx: {
                                        p: 0,
                                        fontSize: 'sm'
                                    },
                                    setFormState: function (formValues) {
                                        return {
                                            HistoryExpanded: !(formValues !== null && formValues !== void 0 && formValues.HistoryExpanded)
                                        };
                                    },
                                    setFieldProps: function (formValues) {
                                        var value = formValues !== null && formValues !== void 0 && formValues.id ? formValues === null || formValues === void 0 ? void 0 : formValues.HistoryExpanded : !(formValues !== null && formValues !== void 0 && formValues.HistoryExpanded);
                                        return {
                                            type: this.type,
                                            children: value ? [/*#__PURE__*/ React.createElement(ExpandLess, null)] : [/*#__PURE__*/ React.createElement(ExpandMore, null)]
                                        };
                                    }
                                }]
                        }, {
                            type: FormItemTypes.Divider,
                            name: '',
                            orientation: 'horizontal',
                            setFieldProps: function (fromValues) {
                                return {
                                    type: FormItemTypes.Divider,
                                    sx: {
                                        my: 1
                                    },
                                    hidden: fromValues === null || fromValues === void 0 ? void 0 : fromValues.HistoryExpanded
                                };
                            }
                        }]
                }, {
                    type: FormItemTypes.Accordian,
                    name: 'HistoryExpanded',
                    value: false,
                    summaryProps: {
                        sx: {
                            display: 'none'
                        }
                    },
                    summary: [],
                    setFieldProps: function (formValues, currValue, field) {
                        return {
                            type: FormItemTypes.Accordian,
                            expanded: formValues !== null && formValues !== void 0 && formValues.id ? currValue : !currValue
                        };
                    },
                    sx: {
                        border: 'none'
                    },
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.List,
                            name: '',
                            value: value === null || value === void 0 ? void 0 : value.history,
                            columnSize: 12,
                            sx: {
                                mb: 2,
                                mx: 2
                            },
                            disableCheckboxSelection: true,
                            variant: 'compact',
                            columns: [{
                                    field: 'DateTime',
                                    flex: 1,
                                    renderCell: function (_ref) {
                                        var row = _ref.row;
                                        return /*#__PURE__*/ React.createElement(Stack, {
                                            direction: "row",
                                            justifyContent: 'space-between',
                                            alignItems: "center"
                                        }, /*#__PURE__*/ React.createElement(Typography, {
                                            p: 1,
                                            fontSize: 'md'
                                        }, "".concat(dayjs(row === null || row === void 0 ? void 0 : row.DateTime).format('DD MMM, YYYY'))), /*#__PURE__*/ React.createElement(Chip, {
                                            size: "small",
                                            variant: "outlined",
                                            color: "info",
                                            label: row === null || row === void 0 ? void 0 : row.Status
                                        }));
                                    }
                                }],
                            elements: [{
                                    type: FormItemTypes.CardComponent,
                                    name: "",
                                    label: "",
                                    columnSize: 12,
                                    sx: {
                                        backgroundColor: 'secondary.50',
                                        m: 1,
                                        border: 0
                                    },
                                    elements: [{
                                            type: FormItemTypes.ContainerItem,
                                            name: '',
                                            columnSize: 12,
                                            spacing: 0,
                                            elements: [{
                                                    type: FormItemTypes.Typography,
                                                    name: 'Name',
                                                    label: 'User :',
                                                    disabled: true,
                                                    setFieldProps: function (formValues, currValue, field) {
                                                        return {
                                                            type: FormItemTypes.Typography,
                                                            value: formValues === null || formValues === void 0 ? void 0 : formValues.Name
                                                        };
                                                    },
                                                    columnSize: 12,
                                                    labelTypographyProps: {
                                                        mb: 0,
                                                        noWrap: true,
                                                        fontWeight: 'medium',
                                                        fontSize: 'sm'
                                                    },
                                                    containerProps: {
                                                        display: 'flex',
                                                        direction: 'row',
                                                        justifyContent: 'space-between'
                                                    }
                                                }, {
                                                    type: FormItemTypes.Typography,
                                                    name: 'Department',
                                                    label: 'Department :',
                                                    disabled: true,
                                                    setFieldProps: function (formValues, currValue, field) {
                                                        return {
                                                            type: FormItemTypes.Typography,
                                                            value: formValues === null || formValues === void 0 ? void 0 : formValues.Department
                                                        };
                                                    },
                                                    columnSize: 12,
                                                    labelTypographyProps: {
                                                        mb: 0,
                                                        noWrap: true,
                                                        fontWeight: 'medium',
                                                        fontSize: 'sm'
                                                    },
                                                    containerProps: {
                                                        display: 'flex',
                                                        direction: 'row',
                                                        justifyContent: 'space-between'
                                                    }
                                                }, {
                                                    type: FormItemTypes.Typography,
                                                    name: 'Ageing',
                                                    label: 'Ageing Days:',
                                                    disabled: true,
                                                    setFieldProps: function (formValues, currValue, field) {
                                                        return {
                                                            type: FormItemTypes.Typography,
                                                            value: formValues === null || formValues === void 0 ? void 0 : formValues.Ageing
                                                        };
                                                    },
                                                    columnSize: 12,
                                                    labelTypographyProps: {
                                                        mb: 0,
                                                        noWrap: true,
                                                        fontWeight: 'medium',
                                                        fontSize: 'sm'
                                                    },
                                                    containerProps: {
                                                        display: 'flex',
                                                        direction: 'row',
                                                        justifyContent: 'space-between'
                                                    }
                                                }, {
                                                    type: FormItemTypes.Typography,
                                                    name: 'Remark',
                                                    label: 'Remark :',
                                                    disabled: true,
                                                    setFieldProps: function (formValues, currValue, field) {
                                                        var _formValues$Remark;
                                                        var _a = useState(false), showFullText = _a[0], setShowFullText = _a[1];
                                                        // Truncate text if longer than 40 characters
                                                        var shouldTruncate = (formValues === null || formValues === void 0 || (_formValues$Remark = formValues.Remark) === null || _formValues$Remark === void 0 ? void 0 : _formValues$Remark.length) > 80;
                                                        var truncatedText = shouldTruncate ? "".concat(formValues.Remark.substring(0, 80)) : formValues === null || formValues === void 0 ? void 0 : formValues.Remark;
                                                        return {
                                                            type: FormItemTypes.Typography,
                                                            value: /*#__PURE__*/ React.createElement(Box, {
                                                                sx: {
                                                                    display: 'inline-flex',
                                                                    alignItems: 'center',
                                                                    flexWrap: 'wrap'
                                                                }
                                                            }, /*#__PURE__*/ React.createElement(Typography, {
                                                                sx: {
                                                                    ml: 14
                                                                },
                                                                component: "span",
                                                                fontSize: 14
                                                            }, showFullText ? formValues === null || formValues === void 0 ? void 0 : formValues.Remark : truncatedText), shouldTruncate && /*#__PURE__*/ React.createElement(Link, {
                                                                component: "button",
                                                                variant: "body2",
                                                                onClick: function () { return setShowFullText(!showFullText); },
                                                                sx: {
                                                                    color: 'primary.main',
                                                                    fontSize: 14,
                                                                    textDecoration: 'none',
                                                                    ml: 14,
                                                                    whiteSpace: 'nowrap'
                                                                }
                                                            }, showFullText ? ' less' : 'more'))
                                                        };
                                                    },
                                                    columnSize: 12,
                                                    labelTypographyProps: {
                                                        mb: 0,
                                                        mr: 1,
                                                        noWrap: true,
                                                        minWidth: "fit-content",
                                                        fontWeight: 'medium',
                                                        fontSize: 'sm'
                                                    },
                                                    containerProps: {
                                                        display: 'flex',
                                                        direction: 'row',
                                                        justifyContent: 'space-between'
                                                    }
                                                }]
                                        }]
                                }],
                            getRowHeight: function () { return 'auto'; }
                        }]
                }]
        }];
    return lgMode ? /*#__PURE__*/ React.createElement(EditableDataGrid, {
        columns: columns,
        rows: value === null || value === void 0 ? void 0 : value.history,
        onChange: onChange,
        disableAddRow: true,
        dataGridHeader: "History",
        disableDeleteRow: true,
        disableToolbarActions: true,
        isCollapsible: true,
        dataGridProps: {
            initialState: {
                pinnedColumns: {
                    right: ["status"]
                },
                density: "standard"
            },
            hideFooter: true,
            disableColumnMenu: true,
            checkboxSelection: false,
            slotProps: {
                toolbar: {
                    chipLabel: "".concat((_value$history$length2 = value === null || value === void 0 || (_value$history2 = value.history) === null || _value$history2 === void 0 ? void 0 : _value$history2.length) !== null && _value$history$length2 !== void 0 ? _value$history$length2 : 0)
                }
            }
        }
    }) : /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        mode: "edit",
        gridProps: {
            spacing: 0,
            p: 0
        }
    });
};
